import Backbone from 'backbone'
import template from 'scoreboard/imports/rest/rest-request-form.hbs'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import _ from 'lodash'
import dropdown from 'scoreboard/components/dropdown'
import constants from 'scoreboard/components/constants'
const { REST, WEB_SERVICE } = constants
import MarkedField from 'scoreboard/components/marked-field'
import $ from 'jquery'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import Connection from 'scoreboard/admin/connections/connection'
import RestConnectionWizard from 'scoreboard/admin/connections/rest/rest-connection-wizard'
import appDisplay from 'scoreboard/components/app-display'
import RestCommunicationDetails from 'scoreboard/imports/rest/rest-communication-details'
import NewRecordOptions from 'scoreboard/datasets/new-record-options'
import HttpRequestForm from 'scoreboard/components/http-request-form'
import handleOauthTokenEndpointException from 'scoreboard/admin/connections/rest/handle-oauth-token-endpoint-exception'
import WsConstants from 'scoreboard/admin/model/ws-constants'
const { WS_VENDOR_TYPE } = WsConstants
import { getDefaultOracleNetSuiteConnection } from 'scoreboard/admin/connections/connection'
import {getWebServiceTypeTitle} from 'scoreboard/admin/connections/rest/ws-utils'
import permissions from '../../components/permissions'
import * as urlToLinks from 'scoreboard/components/urls-to-links'

const RestRequestForm = Backbone.View.extend(/** @lends {RestRequestForm} */{

	tagName: 'form',

	className: 'rest-properties-dialog',

	events: {
		'click .add-connection': 'onClickAddConnection',
		'change [name=connectionId]': 'update'
	},

	/**
	 * Step of import wizard where details for the REST request are specified
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Importable} options.model
	 *
	 * @param {Object} options.dataSourceTypeObj one of the options from
	 * import-data-source-types.js:dataSourceTypeMenuOptions
	 *
	 * @param {Object} options.labels singular and plural labels for the type
	 * of data being imported
	 *
	 * @param {Wizard} options.wizard the wizard this rest request is a part
	 * of
	 *
	 * @param {Object[]} options.connections all import connections, regardless
	 * of type. Of course, we'll only want to display the REST connections
	 *
	 * @param {Boolean} [options.showReplaceAllRecordOptions=false] whether to
	 * show the box options for "Add & Update Records" vs "Replace All Records"
	 */
	initialize: function(options = {}) {
		// #51433 if we add any connections, we need those to be saved on
		// options.connections in case the user navigates forward and back again
		// in the wizard
		options.connections = options.connections || []
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
		this.listenTo(Backbone, 'add:import-connection',
			this.connectionAdded.bind(this))
	},

	render: function() {
		this.$el.html(template(this.context()))
		this.renderNewRecordOptions()
		formHelper.writeToDom(this.restMetadata(), this.el)
		this.options.wizard?.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
		this.renderConnections()
		this.renderHttpRequestForm()
		this.formView.start()
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		// #53653 add connections based on permissions
		if (!(permissions.appAdmin() && permissions.modifyImportConnections())) {
			this.$('.add-connection').hide()
		}
		return this
	},

	/**
	 * Returns this.model.get('dataSourceMetadata')?.restMetadata
	 */
	restMetadata: function() {
		return this.model?.get('dataSourceMetadata')?.restMetadata
	},

	context: function() {
		const titlePrefix = i18n.get('admin.import.datasource.from',
			this.options?.labels?.plural)
		const defaultTitle = i18n.get('admin.importConnections.web-service.restWebService')
		const webServiceTypeTitle = getWebServiceTypeTitle(
			this.options?.dataSourceTypeObj?.type, defaultTitle)
		const title = `${titlePrefix} ${webServiceTypeTitle}`

		const href = 'https://support.spiderstrategies.com/hc/en-us/articles/19855820013204-Importing-Data-from-Web-Services'
		const labelCode = 'admin.import.datasource.from.rest.banner.label'
		const link = urlToLinks.createAnchor(href, labelCode)

		const bannerText = i18n.get('admin.import.datasource.from.rest.banner', webServiceTypeTitle)
		const additionalBannerText = i18n.get('admin.import.datasource.from.rest.banner.additionalInfo', link)
		return {
			title,
			bannerText,
			additionalBannerText,
			showReplaceAllRecordOptions: this.options?.showReplaceAllRecordOptions
		}
	},

	renderHttpRequestForm: function() {
		const connectionId = this.$('[name=connectionId]').val()
		const connection = _.find(this.options.connections, c =>
			c.id == connectionId)
		const baseUrl = connection?.baseUrl
		const restMetadata = this.model?.attributes?.dataSourceMetadata?.restMetadata
		this.httpRequestForm = new HttpRequestForm({
			url: baseUrl,
			useBaseUrl: true,
			urlSuffix: restMetadata?.urlSuffix,
			httpMethod: restMetadata?.httpMethod,
			urlParameters: restMetadata?.urlParameters,
			httpRequestHeaders: restMetadata?.httpRequestHeaders,
			requestBody: restMetadata?.requestBody,
		}).render()
		this.$('.http-request-form-container').append(this.httpRequestForm.$el)

		// #52672 clear any existing errors and re-enable 'Next' button when
		// items are added/removed from the httpRequestForm
		this.httpRequestForm.on('change', () => {
			this.formView?.clearErrors()
			this.formView?.change()
		})
	},

	renderNewRecordOptions: function() {
		this.newRecordOptions = new NewRecordOptions({
			replaceAllRecords: this.model?.get('replaceAllRecords'),
			noConfirmation: true,
			hasPrimaryKeyField: this.model?.hasPrimaryKeyField?.()
		})
		this.$('.new-record-options-container').html(this.newRecordOptions.el)
		this.newRecordOptions.render()
	},

	renderConnections: function() {
		const connections = this.getImportConnections()
		const selectEl = this.$('[name=connectionId]').empty()
		const dataSourceMetadata = this.model?.get('dataSourceMetadata')
		const selectedConnectionId = dataSourceMetadata?.restMetadata?.connectionId
		dropdown.idLabels(selectEl, connections, selectedConnectionId)
		if (!this.connectionsSelect) {
			this.connectionsSelect = new MarkedField({
				el: selectEl,
				validator: connectionsValidator,
				tooltipOptions: {
					placement: 'below'
				}
			}).render()
		}
	},

	getImportConnections: function() {
		// get all REST connections
		let restConnections = _.filter(this.options.connections,
			c => c.wsType === REST)
		restConnections = _.map(restConnections, rc => _.omit(rc, 'icon'))

		const selectedDataSourceType = this.options?.dataSourceTypeObj?.type
		// filter the connections based on the vendor specific connection type that
		// was chosen in the previous step
		if (!_.isNil(selectedDataSourceType) && selectedDataSourceType !== REST) {
			restConnections = _.filter(restConnections, rc => rc.wsVendorType === selectedDataSourceType)
		} else {
			restConnections = _.filter(restConnections, rc => _.isNil(rc.wsVendorType))
		}

		return restConnections
	},

	onClickAddConnection: function() {
		let model = new Connection({
			type: WEB_SERVICE,
			wsType: REST
		})

		// if the user chose a vendor specific connection type, then create one of
		// those as the connection they're adding
		if (this.options?.dataSourceTypeObj?.type === WS_VENDOR_TYPE.ORACLE_NETSUITE) {
			model = getDefaultOracleNetSuiteConnection()
		}
		new RestConnectionWizard({ model }).start()
	},

	update: function() {
		this.httpRequestForm && this.httpRequestForm.remove()
		this.renderHttpRequestForm()
	},

	connectionAdded: function(connection) {
		this.options.connections.push(connection)
		this.renderConnections()
		this.$('[name=connectionId]').val(connection.id).change()
		this.$('.base-url').text(connection.baseUrl)
	},

	saveState: function() {
		this.model.set('replaceAllRecords', this.newRecordOptions.replaceAllRecords)
		let dsm = this.model.attributes.dataSourceMetadata
		if (dsm.restMetadata == null) {
			dsm.restMetadata = {}
		}

		const httpRequestState = this.httpRequestForm.getState()
		_.extend(dsm.restMetadata, httpRequestState)
		// #52012 note the fullUrl is constructed on the server and does not
		// need to be set here
		// don't send the url property from http-request-form.js to the server
		delete dsm.restMetadata.url

		const fromDom = formHelper.readFromDom(this.el)
		dsm.restMetadata.connectionId = fromDom.connectionId
	},

	test: function() {
		const connections = this.getImportConnections()
		if (_.isEmpty(connections)) {
			return i18n.get('admin.importConnections.web-service.rest.error.connectionRequired')
		}
	},

	submit: function() {
		this.saveState()

		return $.ajax({
			method: 'post',
			data: JSON.stringify(this.model.attributes),
			url: this.model.urlRoot + `/validate-rest-connection`,
			success: response => {
				if (this.isShowingCommunicationDetails(response)) {
					this.model.set(response)
					this.showCommunicationDetails(response)
					return
				}
				if (this.options.wizard.isLastStep()) {
					// #35831 when editing an existing db datasource, save
					// *after* validation
					this.save()
				} else {
					this.model.set(response)
					let wizard = this.options.wizard
					if (wizard.steps == wizard.step) {
						this.trigger('done', this.model)
					} else {
						wizard.next()
					}
				}
			},
			error: xhr => handleOauthTokenEndpointException.bind(this)(xhr)
		})
	},

	isShowingCommunicationDetails: function(response) {
		let restMetadata = response?.dataSourceMetadata?.restMetadata
		if (_.isNil(restMetadata)) return true

		if (restMetadata.wsStatusCode >= 300) {
			return true
		}
		try {
			JSON.parse(restMetadata.wsResponse)
			return false
		} catch (e) {
			return true
		}
	},

	showCommunicationDetails: function() {
		appDisplay.dialog(new RestCommunicationDetails({
			model: this.model
		}))
		// reset the next button in the wizard
		this.formView.start()
	},

	autoRemove: true

})

function connectionsValidator(val) {
	if (_.isEmpty(val)) {
		return i18n.get('admin.importConnections.web-service.rest.error.connectionRequired')
	}
}

export default RestRequestForm
export { connectionsValidator }

RestRequestForm.__filename__ = 'imports/rest/rest-request-form.js'
